export default __webpack_public_path__ + "static/thumb-video1-b6b3fc17b31f30182a2f19ce2e29986a.png";